<!--
 * @Description: 
 * @Date: 2020-07-27 11:25:02
-->
<template>
  <div class="box">
    <h4>{{ detail.title }}</h4>
    <div class="authorBox">
      <div class="name">
        <svg-icon iconClass="person" />
        <p>{{ detail.author }}</p>
      </div>
      <span>{{ detail.createDt | transMonths }}</span>
    </div>
    <div v-html="detail.content" class="vhtml"></div>
    <comment
      @event-collection="eventCollection"
      :is-collection="detail.isCollect"
      :qa-id="detail.id"
      :type="type"
      :name="detail.title"
    ></comment>
    <ToYsh />
  </div>
</template>
<script>
import { contentManage } from '@/api/ajax';
import { getStorage } from '@/utils/storage';
import detailMixin from '@/mixins/detail';
import ToYsh from '@/components/toYsh';

export default {
  mixins: [detailMixin],
  components: { ToYsh },
  data() {
    return {
      ajax: contentManage.bingliDetail,
      type: 2 // 1:资讯 2:病例 3:直播 4:录播  5:问卷
    };
  }
};
</script>
<style lang="less" scoped>
.box {
  padding: 0.64rem 0.4rem;
  padding-bottom: 2rem;
  h4 {
    font-size: 0.53rem;
    font-weight: 500;
    color: rgba(50, 50, 53, 1);
    line-height: 0.53rem;
    margin-bottom: 0.64rem;
  }
  .authorBox {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.63rem;
    .name {
      display: flex;
      svg {
        color: #3667ec;
        width: 0.43rem;
        height: 0.48rem;
        margin-right: 0.16rem;
      }
      p {
        color: #9ea0aa;
        font-size: 0.48rem;
        margin-right: 0.43rem;
        line-height: 1;
      }
    }
    span {
      color: #aeafb3;
      font-size: 0.35rem;
      line-height: 1;
    }
  }
}
</style>
